import jump from 'jump.js';
import validate from '../../vendor/validate';
import validateDefaults from '../form/validate-defaults';
import validateMatchValue from '../form/validate-match-value';

export default function () {
  const settings = Object.assign({}, validateDefaults, {
    selector: '.js-steps-form-validate',
  });

  /**
   * Validate the form
   */
  window.validateSteps = validate;
  window.validateSteps.init(settings);
};
